import React from 'react';
import { Tooltip } from 'antd';

import { QuestionCircleOutlined} from '@ant-design/icons';
import './index.css';

export const PanelHeader = (props) => {
  const {headerText , tooltip} = props;
  
  
  return (
    <h4> {headerText} <Tooltip title={tooltip}><QuestionCircleOutlined 
    style = {{fontSize : '1em'}}
    /> </Tooltip ></h4>
  );
}


